import { render, staticRenderFns } from "./TrendingNow.vue?vue&type=template&id=13c122d8&scoped=true"
import script from "./TrendingNow.vue?vue&type=script&lang=js"
export * from "./TrendingNow.vue?vue&type=script&lang=js"
import style0 from "./TrendingNow.vue?vue&type=style&index=0&id=13c122d8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c122d8",
  null
  
)

export default component.exports